import { toast } from "react-toastify";
import { fetchChargeRuleSuccess, fetchChargeRuleFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../interceptor/interceptor";
import { GET_ALL_CHARGERULE_API } from "../constants/constants";
import { setSuccessMessage } from "../toastMessage/action";

export const getAllChargeRule = (setLoading) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${GET_ALL_CHARGERULE_API}`, 'GET').then((response) => {
        setLoading(false)
        if (!response.error) {
            dispatch(fetchChargeRuleSuccess(response?.data || []))
            dispatch(setSuccessMessage(true))
        }
        if (response.error) {
            if (response.error.code === 'NotFound') {
            dispatch(fetchChargeRuleSuccess([]))
            } else {
            dispatch(fetchChargeRuleFailure(response.error.message))
            toast.error(`${response.error.message}`)
            }
        }
    }).catch((errorResp) => { })
}